$(document).ready(function() {
	let deliveryToday = new Date();
	let deliveryDay = deliveryToday.getDay();
	let currentHours = deliveryToday.getHours();
  console.log(deliveryDay);
	let cutOffHours = 20;
	if(deliveryDay == 1) {
		$(".mondayHalton").addClass("delivery-active");
		$(".delivery-regionHalton").addClass("delivery-active-region");
	} else if(deliveryDay == 2) {
		$(".tuesdayPeel").addClass("delivery-active");
		$(".delivery-regionPeel").addClass("delivery-active-region");
	} else if(deliveryDay == 3) {
		$(".wednesdayToronto").addClass("delivery-active");
		$(".delivery-regionToronto").addClass("delivery-active-region");
	} else if(deliveryDay == 4) {
		$(".thursdayYork").addClass("delivery-active");
		$(".delivery-regionYork").addClass("delivery-active-region");
	} else if(deliveryDay == 5) {
		$(".fridayDurham").addClass("delivery-active");
		$(".delivery-regionDurham").addClass("delivery-active-region");
	};
	Date.prototype.getWeekDay = function(d) {
		if(d) {
			var next = this;
			next.setDate(this.getDate() - this.getDay() + d);
          // return next.toDateString();
			return next.toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"});
		}
	}
	Date.prototype.getNextWeekDay = function(d) {
		if(d) {
			var next = this;
			next.setDate(this.getDate() - this.getDay() + 7 + d);
			// return next.toDateString();
          return next.toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"});
		}
	}
	var deliveryMonday = new Date();
	var thisMonday = deliveryMonday.getWeekDay(1);
	var deliveryTuesday = new Date();
	var thisTuesday = deliveryTuesday.getWeekDay(2);
	var deliveryWednesday = new Date();
	var thisWednesday = deliveryWednesday.getWeekDay(3);
	var deliveryThursday = new Date();
	var thisThursday = deliveryThursday.getWeekDay(4);
	var deliveryFriday = new Date();
	var thisFriday = deliveryFriday.getWeekDay(5);
	var deliveryNextMonday = new Date();
	var nextMonday = deliveryNextMonday.getNextWeekDay(1);
	var deliveryNextTuesday = new Date();
	var nextTuesday = deliveryNextTuesday.getNextWeekDay(2);
	var deliveryNextWednesday = new Date();
	var nextWednesday = deliveryNextWednesday.getNextWeekDay(3);
	var deliveryNextThursday = new Date();
	var nextThursday = deliveryNextThursday.getNextWeekDay(4);
	var deliveryNextFriday = new Date();
	var nextFriday = deliveryNextFriday.getNextWeekDay(5);
	if(deliveryDay < 0) {
		$(".mondayHalton .delivery-date").html(thisMonday);
	} else if(deliveryDay == 0) {
		if(currentHours < cutOffHours) {
			$(".mondayHalton .delivery-date").html(thisMonday);
		} else if(currentHours >= cutOffHours) {
			$(".mondayHalton .delivery-date").html(nextMonday);
		}
	} else if(deliveryDay > 0) {
		$(".mondayHalton .delivery-date").html(nextMonday);
	};
	if(deliveryDay < 1) {
		$(".tuesdayPeel .delivery-date").html(thisTuesday);
	} else if(deliveryDay == 1) {
		if(currentHours < cutOffHours) {
			$(".tuesdayPeel .delivery-date").html(thisTuesday);
		} else if(currentHours >= cutOffHours) {
			$(".tuesdayPeel .delivery-date").html(nextTuesday);
		}
	} else if(deliveryDay > 1) {
		$(".tuesdayPeel .delivery-date").html(nextTuesday);
	};
	if(deliveryDay < 2) {
		$(".wednesdayToronto .delivery-date").html(thisWednesday);
	} else if(deliveryDay == 2) {
		if(currentHours < cutOffHours) {
			$(".wednesdayToronto .delivery-date").html(thisWednesday);
		} else if(currentHours >= cutOffHours) {
			$(".wednesdayToronto .delivery-date").html(nextWednesday);
		}
	} else if(deliveryDay > 2) {
		$(".wednesdayToronto .delivery-date").html(nextWednesday);
	};
	if(deliveryDay < 3) {
		$(".thursdayYork .delivery-date").html(thisThursday);
	} else if(deliveryDay == 3) {
		if(currentHours < cutOffHours) {
			$(".thursdayYork .delivery-date").html(thisThursday);
		} else if(currentHours >= cutOffHours) {
			$(".thursdayYork .delivery-date").html(nextThursday);
		}
	} else if(deliveryDay > 3) {
		$(".thursdayYork .delivery-date").html(nextThursday);
	};
	if(deliveryDay < 4) {
		$(".fridayDurham .delivery-date").html(thisFriday);
	} else if(deliveryDay == 4) {
		if(currentHours < cutOffHours ) {
			$(".fridayDurham .delivery-date").html(thisFriday);
		} else if(currentHours >= cutOffHours) {
			$(".fridayDurham .delivery-date").html(nextFriday);
		}
	} else if(deliveryDay > 4) {
		$(".fridayDurham .delivery-date").html(nextFriday);
	};
});